import mvtArticle from '@/common/components/mvtarticle/mvt-article.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import mvtWelcome from '@/common/components/mvtwelcome/mvt-welcome.vue';
import faqConf from '@/common/store/glb/data.faqs';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import { mapGetters, mapActions } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { parseQueryString } from '@/common/utilities/nojq/_utilities.js';
import { handleMortgagePageCta } from '@/common/utilities/mortgagePageCta.js';

export default {
    name: 'pagePreapporval',
    inject: ['$eventBus'],
    data() {
        return {
            zipcode: '',
            tag: null,
            faqQuery: null,
            ctaList: [
                { text: 'Get Started', utmcta: 'preapprovalpage' },
                { text: 'Get Preapproved', utmcta: 'mortg_preapproval' },
                { text: 'Apply', utmcta: 'mortg_apply' },
            ],
        };
    },
    components: {
        mvtHeader,
        mvtDialogCenter,
        mvtArticle,
        mvtFaq,
        mortgageTools,
        mvtWelcome,
        mvtFooter,
    },
    methods: {
        ...mapActions('glb', ['getGeoInfoBySearch']),
        show3rdPartyForm() {
            if (!this.zipcode) {
                return;
            }
            handleMortgagePageCta({
                getSplit: this.getSplit,
                glb: this.glb,
                zipcode: this.zipcode,
                utmContent: this.cta.text,
                ctaLabel: this.cta.text,
                evt: null,
                eventBus: this.$eventBus,
                trigger: this.$options.name,
            });
        },
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getSplit']),
        cta() {
            return this.ctaList[2];
        },
    },
    mounted() {
        this.tag = this.glb.articleConfig.tag.preApproval + '';
        this.faqQuery = faqConf.preapproval;
        this.$eventBus.$emit('eventbus-pageLoaded');
        var winOpt = {};
        if (window && window.location && window.location.search) {
            winOpt = parseQueryString(window.location.search);
        }
        this.zipcode = winOpt.zipcode || '';
        let ctaTxt = this.zipcode ? this.ctaList[0].text : '';
        this.show3rdPartyForm(ctaTxt);
    },
};
